import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="author-autocomplete"
// Debounced author search: updates the suggestions Turbo Frame `src` as the
// user types, and submits the main form once a suggestion is picked.
export default class extends Controller {
  static targets = ["input", "suggestions", "spinner"]
  static values = { url: String, minLength: { type: Number, default: 3 } }

  initialize() {
    this.search = debounce(this.search.bind(this), 300);
  }

  search() {
    const query = this.inputTarget.value.trim();

    if (query.length < this.minLengthValue) {
      this.hideSpinner();
      this.clearSuggestions();
      return;
    }

    this.showSpinner();
    this.suggestionsTarget.src = `${this.urlValue}?q=${encodeURIComponent(query)}`;
  }

  choose(event) {
    this.inputTarget.value = event.params.name;
    this.hideSpinner();
    this.clearSuggestions();
    this.submit();
  }

  submit() {
    this.element.requestSubmit();
  }

  clearSuggestions() {
    this.suggestionsTarget.removeAttribute("src");
    this.suggestionsTarget.innerHTML = "";
  }

  // Toggle via inline `display` rather than the `hidden` attribute: FontAwesome's
  // `.fa` class sets `display`, which overrides the `[hidden]` UA rule.
  showSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "inline-block";
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "none";
  }
}
